import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import metrics from '../lib/common/metrics';
import { IconChevronUp, IconChevronDown } from '../components/Icons';

class PanelContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState(
      prevState => {
        return {
          isOpen: !prevState.isOpen
        };
      },
      () => {
        metrics.action(
          'Toggle Control-Panel',
          this.state.isOpen ? 'open' : 'close'
        );
      }
    );
  }

  render() {
    const isOpen = this.state.isOpen;
    return (
      <div
        className={classnames({
          'syos-panel': true,
          'syos-panel--open': isOpen
        })}
      >
        <button
          className={classnames({
            'u-syos-button-reset': true,
            'syos-panel-toggle': true,
            'syos-panel-toggle--show': !isOpen
          })}
          onClick={this.handleToggle}
        >
          {isOpen ? 'Hide controls' : 'Show controls'}
          {isOpen ? <IconChevronUp /> : <IconChevronDown />}
        </button>

        <div className="syos-panel__inner">
          {React.Children.map(this.props.children, function(child) {
            return child.props.isAvailable ? (
              <div
                className={classnames({
                  'syos-panel__segment': true,
                  'syos-panel__segment--available': child.props.isAvailable
                })}
              >
                {child}
              </div>
            ) : null;
          })}
        </div>
      </div>
    );
  }
}

PanelContainer.propTypes = {
  children: PropTypes.node
};

export default PanelContainer;



// WEBPACK FOOTER //
// ./src/javascripts/containers/PanelContainer.js